export function defaultStateOptions() {
  return [{
    label: 'checagem',
    value: 'check',
  }, {
    label: 'análise',
    value: 'analyze',
  }, {
    label: 'pendente',
    value: 'hang',
  }, {
    label: 'restrição',
    value: 'restrict',
  }, {
    label: 'pré_aprovada',
    value: 'preapprove',
  }, {
    label: 'aprovada',
    value: 'approve',
  }, {
    label: 'recusada',
    value: 'refuse',
  }, {
    label: 'faturada',
    value: 'invoice',
  }, {
    label: 'desistencia',
    value: 'dismiss',
  }];
}

export function getAttemptOption(state, prop = 'value') {
  return defaultStateOptions().find(o => o[prop] === state) || {};
}

function reduceBalloons(reducing, { value_cents: value }) {
  return {
    ...reducing,
    [value]: (reducing[value] || 0) + 1,
  };
}

export function extractBalloons(attemptOrCondition, quantityProperty = 'term_financing', valueProperty = 'quota_in_cents', flowType = 'array') {
  const {
    [quantityProperty]: quantity,
    [valueProperty]: value,
  } = attemptOrCondition;

  let {
    payment_flow: flow,
  } = attemptOrCondition;

  if (flowType !== 'array') {
    flow = Object
      .keys(flow)
      .map(i => ({
        value_cents: flow[i],
        installment_number: i,
      }));
  }

  if (!flow || !flow.length) {
    return {
      installments: {
        quantity,
        value,
      },
    };
  }

  const distinct = flow.reduce(reduceBalloons, {});
  const max = Math.max(...Object.values(distinct));
  const main = Object.keys(distinct).find(i => distinct[i] === max);

  return {
    installments: {
      quantity: distinct[main],
      value: parseInt(main, 10),
    },
    balloons: Object
      .keys(distinct)
      .filter(i => i !== main)
      .map(i => parseInt(i, 10))
      .map(i => ({
        quantity: distinct[i],
        value: i,
        months: flow
          .filter(f => f.value_cents === i)
          .map(f => f.installment_number)
          .sort((a, b) => a - b),
      })),
  };
}
